import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Search } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-[var(--page-bg)] text-foreground flex flex-col items-center justify-center sci-bg-grid">
      {/* Logo */}
      <Link href="/" className="flex items-center gap-2.5 mb-16 group">
        <div className="w-8 h-8 rounded-lg flex items-center justify-center shadow-lg shadow-blue-500/30"
          style={{ background: 'linear-gradient(135deg, #2563EB 0%, #06B6D4 50%, #818CF8 100%)' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 3h6v8l4 7H5l4-7V3z" /><path d="M9 3h6" />
            <circle cx="12" cy="15" r="1" fill="white" stroke="none" />
          </svg>
        </div>
        <span className="font-bold text-lg text-white tracking-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Science<span className="text-blue-400">Token</span>
        </span>
      </Link>

      {/* 404 Content */}
      <div className="text-center max-w-[480px] px-4">
        <div className="text-[120px] font-bold leading-none sci-gradient-text mb-4"
          style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          404
        </div>
        <h1 className="text-2xl font-semibold text-white mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          {t("notFound.title")}
        </h1>
        <p className="text-slate-400 mb-8 leading-relaxed">
          {t("notFound.desc")}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link href="/">
            <Button className="btn-primary-sci gap-2 px-6 h-11">
              <ArrowLeft size={15} />
              {t("notFound.back")}
            </Button>
          </Link>
          <Link href="/llms">
            <Button variant="ghost" className="btn-outline-sci gap-2 px-6 h-11">
              <Search size={15} />
              {t("notFound.explore")}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
